import React, { FC, useMemo, useState } from 'react';
import { Button, Tag } from '@bedrock/components';
import { ChevronDown, ChevronUp } from '@bedrock/icons-react';
import { ProDetailList } from '@bedrock/eed-react';
import {
  FormItemAttachmentDescription,
  FormItemAttachmentEffectiveDate,
  FormItemAttachmentFile,
  FormItemAttachmentRemark,
  FormItemAttachmentType,
  FormItemOtherAttachmentDetailList,
} from '@purchase/supplier';
import dayjs from 'dayjs';

const renderEffectiveStatus = (_: unknown, record: any) => {
  const dateInfo = record?.fileExpiredDateOrLongEffective;
  if (!dateInfo || (!dateInfo.longEffective && !dateInfo.fileExpiredDate)) {
    return '-';
  }
  if (dateInfo.longEffective) {
    return <Tag color="light-green" text="正常" size="xSmall" />;
  }
  const expireDate = dayjs(dateInfo.fileExpiredDate);
  const today = dayjs();
  const diffDays = expireDate.diff(today, 'day');
  if (diffDays < 0) {
    return <Tag color="light-red" text="已过期" size="xSmall" />;
  }
  if (diffDays <= 60) {
    return (
      <Tag color="light-orange" text={`${diffDays}天后过期`} size="xSmall" />
    );
  }
  return <Tag color="light-green" text="正常" size="xSmall" />;
};

export interface SupplierAttachmentTableProps {
  hasExtra: boolean;
}

const SupplierAttachmentTable: FC<SupplierAttachmentTableProps> = ({
  hasExtra,
}) => {
  const [showAll, setShowAll] = useState(false);

  const name = useMemo(
    () => [
      'vendorAttachmentInfo',
      showAll ? 'otherAttachments' : 'defaultOtherAttachments',
    ],
    [showAll]
  );

  return (
    <>
      <FormItemOtherAttachmentDetailList
        name={name}
        fieldProps={{ scroll: { x: 1120 } }}
      >
        <FormItemAttachmentType
          label="附件类型"
          name="attachmentType"
          meta={{
            columnProps: {
              width: 200,
              className: 'font-semibold',
              fixed: true,
            },
          }}
        />
        <FormItemAttachmentDescription label="附件描述" name="attachmentDesc" />
        <ProDetailList.Item
          label="时效状态"
          name="fileExpiredDateOrLongEffective"
          meta={{ columnProps: { width: 140 } }}
        >
          {renderEffectiveStatus}
        </ProDetailList.Item>
        <FormItemAttachmentEffectiveDate
          label="文件到期日"
          name="fileExpiredDateOrLongEffective"
          meta={{ columnProps: { width: 140 } }}
        />
        <ProDetailList.Item
          label="附件"
          name="attachmentFiles"
          meta={{ columnProps: { width: 240 } }}
        >
          {(_, record) => (
            <FormItemAttachmentFile
              disableDownload={
                record?.attachmentType ===
                FormItemAttachmentType.Type.LegalRepresentativeIdCardCopy
              }
            />
          )}
        </ProDetailList.Item>
        <FormItemAttachmentRemark label="备注" name="remark" />
      </FormItemOtherAttachmentDetailList>

      {hasExtra && (
        <div className="mt-2 text-xs text-color-2">
          <Button
            type="link"
            onClick={() => setShowAll((prev) => !prev)}
            suffixIcon={showAll ? <ChevronUp /> : <ChevronDown />}
          >
            {showAll ? '收起' : '展开全部'}
          </Button>
        </div>
      )}
    </>
  );
};

export default SupplierAttachmentTable;
